import { AuthContainer, AuthProvider, type Credentials } from "@pharaday/auth";
import { useMutation } from "@tanstack/react-query";

const useLogin = () => {
  return useMutation({
    mutationFn: (credentials: Credentials) => AuthContainer.get(AuthProvider).signIn(credentials),
  });
};

export default useLogin;
